import { sendContactForm } from "./asyncThunk";

export const sendContactFormBuilder = (builder) => {
  builder.addCase(sendContactForm.pending, (state) => {
    state.loading = true;
    state.error = null;
  });
  builder.addCase(sendContactForm.fulfilled, (state, { payload }) => {
    state.loading = false;
    state.success = true;
    state.message = payload.message;
    state.error = null;
  });
  builder.addCase(sendContactForm.rejected, (state, { payload }) => {
    state.loading = false;
    state.success = false;
    state.error = payload;
  });
};